import Reveal from "@/components/base/Reveal";

const CARDS = [
  {
    eyebrow: "Meu equipamento parou",
    title: "Preciso de assistência",
    description:
      "Problemas de funcionamento, manutenção, recuperação ou avaliação técnica do equipamento.",
    cta: "Encontrar solução",
    href: "#servicos",
    icon: "ri-tools-line",
  },
  {
    eyebrow: "Preciso de um motor",
    title: "Quero comprar",
    description:
      "Encontre um motor elétrico adequado à sua aplicação, potência e necessidade industrial.",
    cta: "Ver motores",
    href: "#produtos",
    icon: "ri-cpu-line",
  },
  {
    eyebrow: "Preciso de uma solução industrial",
    title: "Produtos e equipamentos",
    description:
      "Bombas, redutores, motoredutores e soluções de automação e controle para sua operação.",
    cta: "Explorar soluções",
    href: "#solucoes",
    icon: "ri-settings-3-line",
  },
];

export default function IntentNavigation() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <Reveal>
          <h2 className="text-center font-heading text-3xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            Como podemos ajudar?
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-base text-foreground-600">
            Escolha abaixo o seu momento e acesse a solução adequada para a sua necessidade.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {CARDS.map((card, i) => (
            <Reveal key={card.title} delay={i * 90}>
              <a
                href={card.href}
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-all duration-200 hover:-translate-y-1 hover:border-primary-300"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${card.icon} text-2xl`} aria-hidden="true" />
                </span>
                <p className="mt-5 text-xs font-bold uppercase tracking-[0.14em] text-accent-600">
                  {card.eyebrow}
                </p>
                <h3 className="mt-2 font-heading text-xl font-bold text-foreground-950">
                  {card.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {card.description}
                </p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-primary-700">
                  {card.cta}
                  <i
                    className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
                    aria-hidden="true"
                  />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}